import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImpersonationModal from './Modal';
import ImpersonationExpiredModal from './ExpiredModal';
import { inject, observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { isAuthorized } from 'utils/auth';

import './Impersonation.scss';

@inject('AppState')
@observer
export default class Impersonation extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
	};

	AppState = this.props.AppState;

	@observable showModal = false;

	@action
	toggleModal() {
		this.AppState.resetUserToImpersonate();
		this.showModal = !this.showModal;
	}

	canSeeImpersonationComponent() {
		return isAuthorized(['Impersonate']) || this.AppState.isImpersonated;
	}

	render() {
		if (!this.canSeeImpersonationComponent()) {
			return null;
		}

		return (
			<div className="Impersonation">
				<button
					id="ImpersonationSearchButton"
					className="Impersonation-search search-user btn"
					onClick={this.toggleModal.bind(this)}
				/>
				<ImpersonationModal
					show={this.showModal}
					onRequestClose={this.toggleModal.bind(this)}
				/>
				<ImpersonationExpiredModal />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Impersonation/index.js